import script from "./AuthMobileError.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthMobileError.vue?vue&type=script&setup=true&lang=js"

import "./AuthMobileError.vue?vue&type=style&index=0&id=fe95d91a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe95d91a"]])

export default __exports__